import Slider from "react-slick";
import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css';

const ImageWithPlaceholder = ({ src, alt }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className="image-wrapper">
            {!loaded && <div className="placeholder"></div>}
            <img
                src={src}
                alt={alt}
                className={`slide_img ${loaded ? 'loaded' : ''}`}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
};

const Home = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        arrows: true,
        adaptiveHeight: true, // 슬라이더 높이 조정

    };

    return(
        <>
        <div className="home_container">
            <div className="home_top">
                <h2 className="focus-in-contract">“하모니카로 모두가 함께 즐기며 소통하는 아름다운 세상”</h2>  
                <img src='/images/home.png' alt="홈 이미지"/>
            </div>
            <h3>제 12회 서울국제하모니카 페스티벌 갤러리</h3>
            <div className="slider-container">
            <Slider {...settings}>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/eYMBVJA.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/HcoJU8q.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/DrUsx8L.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/NbxZoJP.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/PqLeuXN.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/oSHwUtp.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/j0kIBuf.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/WoQElIv.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/8EsUpBM.jpg" className="slide_img" alt="이미지"/>
                </div>
                <div>
                    <ImageWithPlaceholder src="https://imgur.com/7mnNg9L.jpg" className="slide_img" alt="이미지"/>
                </div>
            </Slider>
            </div>
            <div className="home-mid">
                <div style={{textAlign:'left'}} className="mid-left">
                    <h3>문의사항</h3>
                    <a href = "tel:028485061">📞 <strong>전화번호</strong>: 02-848-5061<br/></a>
                    <a href="mailto: sihf2013@naver.com">📧 <strong>이메일</strong>: sihf2013@naver.com <br/></a>
                    🧭 <strong>주소</strong>: 서울 영등포구 대방천로 155 신풍두산위브센티움 208호 <br/>
                </div>
                <div className="mid-right">
                    <div className="mid-link" onClick={() => window.open("https://cafe.naver.com/sihf")}>
                    <img src = '/images/navercafe.png' alt = '네이버 카페'/>
                    <label>네이버 카페</label>
                    </div>
                    <div className="mid-link" onClick={() => window.open("https://cafe.daum.net/KHE")}>
                    <img src = '/images/daumcafe.png' alt="다음카페"/>
                    <label>다음 카페</label>
                    </div>
                    <div className="mid-link" onClick={() => window.open("https://www.youtube.com/@SIHF-uv5mk")}>
                    <img src = '/images/youtube.png' alt="유튜브"/>
                    <label>유튜브 채널</label>
                    </div>
                </div>
            </div>
                </div>
        </>
    )

}
export default Home;
